'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var log = require('debug')('mss:handle');

var BufferList = require('bl/BufferList');

var multistream = require('./multistream');

var handshake = require('it-handshake');

var _require = require('./constants'),
    PROTOCOL_ID = _require.PROTOCOL_ID;

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, protocols) {
    var _handshake, writer, reader, rest, shakeStream, protocol;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            protocols = Array.isArray(protocols) ? protocols : [protocols];
            _handshake = handshake(stream), writer = _handshake.writer, reader = _handshake.reader, rest = _handshake.rest, shakeStream = _handshake.stream;

          case 2:
            if (!true) {
              _context.next = 24;
              break;
            }

            _context.next = 5;
            return multistream.read(reader);

          case 5:
            protocol = _context.sent.toString();
            log('read "%s"', protocol);

            if (!(protocol === PROTOCOL_ID)) {
              _context.next = 11;
              break;
            }

            log('respond with "%s" for "%s"', PROTOCOL_ID, protocol);
            multistream.write(writer, PROTOCOL_ID);
            return _context.abrupt("continue", 2);

          case 11:
            if (!protocols.includes(protocol)) {
              _context.next = 16;
              break;
            }

            multistream.write(writer, protocol);
            log('respond with "%s" for "%s"', protocol, protocol);
            rest();
            return _context.abrupt("return", {
              stream: shakeStream,
              protocol: protocol
            });

          case 16:
            if (!(protocol === 'ls')) {
              _context.next = 20;
              break;
            }

            // <varint-msg-len><varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n\n
            multistream.write(writer, new BufferList(protocols.map(function (p) {
              return multistream.encode(p);
            })));
            log('respond with "%s" for %s', protocols, protocol);
            return _context.abrupt("continue", 2);

          case 20:
            multistream.write(writer, 'na');
            log('respond with "na" for "%s"', protocol);
            _context.next = 2;
            break;

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();